import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import CodeFormDialog from '../../components/codemng/CodeFormDialog';
import { useDispatch } from 'react-redux';
import { listCodes } from '../../modules/comCode';
import client from '../../lib/api/client';

const CodeFormContainer = ({ type, data, open, handleClose }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  let initialValues = {
    blcCd: data && data.blcCd !== undefined ? data.blcCd : '',
    mlcCd: data && data.mlcCd !== undefined ? data.mlcCd : '',
    slcCd: data && data.slcCd !== undefined ? data.slcCd : '',
    itemNm: data && data.itemNm !== undefined ? data.itemNm : '',
    itemDesc: data && data.itemDesc !== undefined ? data.itemDesc : '',
    revVal1: data && data.revVal1 !== undefined ? data.revVal1 : '',
    revVal2: data && data.revVal2 !== undefined ? data.revVal2 : '',
    step: data && data.step !== undefined && data.step !== null ? data.step : 1,
    useYn: data && data.useYn !== undefined ? data.useYn : true,
  };



  const validationSchema = yup.object({
    blcCd: yup.string('').required('대분류코드를 입력하세요'),
    mlcCd: yup.string().nullable(''),
    slcCd: yup.string().nullable(''),
    itemNm: yup.string('').required('코드명을 입력하세요'),
    itemDesc: yup.string().nullable(''),
    revVal1: yup.string().required('값1을 입력하세요'),
    revVal2: yup.string().required('값2을 입력하세요'),
    step: yup.number('정렬순서는 숫자만 가능합니다').positive().required('정렬순서를 입력하세요'),
    useYn: yup.boolean(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      let dataToSubmit = {
        blcCd: values.blcCd,
        mlcCd: values.mlcCd,
        slcCd: values.slcCd,
        itemNm: values.itemNm,
        itemDesc: values.itemDesc,
        revVal1: values.revVal1,
        revVal2: values.revVal2,
        step: values.step,
        useYn: values.useYn ? 'Y' : 'N',
      };

      // console.log(type,dataToSubmit);

      if (type === 'add') {
        client
          .post(`/api/v1/common/info`, dataToSubmit)
          .then((res) => {
            if (res.data) {
              dispatch(listCodes())
            };

          })
          .catch((err) => {
            let message =
              typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
            enqueueSnackbar(message, {
              variant: 'error',
            });
          });
      } else {
        dataToSubmit.commonUuid = data.id;
        //console.log(JSON.stringfy(dataToSubmit));

        client
          .put(`/api/v1/common/info/${data.id}`, dataToSubmit)
          .then((res) => {
            if (res.data) {
              dispatch(listCodes())
            };
          })
          .catch((err) => {
            let message =
              typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
            enqueueSnackbar(message, {
              variant: 'error',
            });
          });
      }
      formik.resetForm();
      setSubmitting(false);
      handleClose();
    },
  });

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <div>
      <CodeFormDialog
        type={type}
        open={open}
        handleClose={onClose}
        formik={formik}
      />
    </div>
  );
};

export default CodeFormContainer;
